import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-customer-bus-co',
  templateUrl: './customer-bus-co.component.html',
  styleUrls: ['./customer-bus-co.component.css']
})
export class CustomerBusCoComponent implements OnInit {
    customerBusCoKeyno;

    public accCustNoButtons: FormButton[] = [
        { id: 'calculator', type: 'primary', icon: 'fa fa-calculator', onClick: () => this.openCalculator('acc_cust_no') },
        { id: 'new', type: 'primary', icon: 'fas fa-plus', onClick: () => this.count('acc_cust_no') }
    ];

    public accSuppNoButtons: FormButton[] = [
        { id: 'calculator', type: 'primary', icon: 'fa fa-calculator', onClick: () => this.openCalculator('acc_supp_no') },
        { id: 'new', type: 'primary', icon: 'fas fa-plus', onClick: () => this.count('acc_supp_no') }
    ];

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.customerBusCoKeyno = this.stateService.getStateParams()['customerbusco_keyno'];
    }

    private async loadEdit() {
        if (!!this.customerBusCoKeyno) {
            this.edit = (await this.datatask.Post(1293, { customerbusco_keyno: this.customerBusCoKeyno }))[0];
        }
    }

    private async count(id: string) {
        if(!this.edit) return;

        switch (id) {
            case 'acc_cust_no':
                if (id === 'acc_cust_no') {
                    const response = (await this.datatask.Post(678, { counter_id: this.edit.acc_cust_no_counter_id }))[0];

                    if (!!response?.nextnumber) {
                        this.edit.acc_cust_no = response?.nextnumber;
                    }
                }
                break;
            case 'acc_supp_no':
                if (id === 'acc_supp_no') {
                    const response = (await this.datatask.Post(678, { counter_id: this.edit.acc_supp_no_counter_id }))[0];

                    if (!!response?.nextnumber) {
                        this.edit.acc_supp_no = response?.nextnumber;
                    }
                }
                break;
            default:
                break;
        };
    }

    private async openCalculator(id: string) {
        if (!this.edit) return;

        switch (id) {
            case 'acc_cust_no':
                if (id === 'acc_cust_no') {
                    const value = await this.modal.showCalculator(this.edit.acc_cust_no);

                    this.edit.acc_cust_no = value;
                }
                break;
            case 'acc_supp_no':
                if (id === 'acc_supp_no') {
                    const value = await this.modal.showCalculator(this.edit.acc_supp_no);

                    this.edit.acc_supp_no = value;
                }
                break;
            default:
                break;
        };
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1295, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    customerbusco_keyno: string;
    cust_no: string;
    businessco_no: string;
    businessco_companyname: string;
    acc_cust_no: string | any;
    acc_supp_no: string | any;
    access: string;
    page_heading: string;
    acc_cust_no_counter_id: string;
    acc_supp_no_counter_id: string;
    is_customer: string;
    is_supplyer: string;
}
